var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-text-panel"},[_vm._m(0),_c('div',{staticClass:"info-text-panel__text"},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-text-panel__icon"},[_c('img',{attrs:{"src":require("@/assets/img/info-text-panel-icon.svg"),"alt":""}})])
}]

export { render, staticRenderFns }